import React, { Component } from 'react';
import { View, TouchableHighlight, Image, Text, TouchableOpacity } from 'react-native';
import styles from './styles';
export default class Accordion extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: true, debitExpand: false, internetExpand: false };
    console.log('props!!!!!!!!', props);
  }

  toggle = (title) => {
    this.props.onClickTabs(title);
  };

  render() {
    let toggeIconforDebitCard = (
      <Image
        style={{
          width: 24,
          height: 24,
        }}
        source={require('../../../assets/images/arrowforward.png')}
      />
    );

    let toggeIconInternetBanking = (
      <Image
        style={{
          width: 24,
          height: 24,
        }}
        source={require('../../../assets/images/arrowforward.png')}
      />
    );

    if (this.props.CloseOpenDebitCard) {
      toggeIconforDebitCard = (
        <Image
          style={{
            width: 30,
            height: 30,
          }}
          source={require('../../../assets/images/arrowdown.png')}
        />
      );
    }
    if (this.props.CloseOpenInternetBanking) {
      toggeIconInternetBanking = (
        <Image
          style={{
            width: 30,
            height: 30,
          }}
          source={require('../../../assets/images/arrowdown.png')}
        />
      );
    }
    return (
      <View >
        <TouchableOpacity
          onPress={() => this.toggle(this.props.title)}
          style={styles.expandableView}
        >
          <View style={this.props.accordianHead}>
            <View style={this.props.iconText}>
              <Image
                style={this.props.imgStyles}
                source={this.props.imgUrl}
              ></Image>

              <Text style={this.props.accordianText}>{this.props.title}</Text>
            </View>
            {this.props.title == 'Debit/Credit Card' && toggeIconforDebitCard

            }
            {this.props.title != 'Debit/Credit Card' && toggeIconInternetBanking

            }
          </View>
        </TouchableOpacity>
        {this.props.CloseOpenDebitCard && <View >{this.props.children}</View>}
        {this.props.CloseOpenInternetBanking && (
          <View >{this.props.children}</View>
        )}
      </View>
    );
  }
}
